module.exports = __webpack_public_path__ + "img/icon_choosed.ab6a3ca5.svg";